import React, { useEffect, useState } from "react";
// interface
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import LoadingIconWithText from "components/LoadingIconWithText";
import * as url from "../../../api/urls"
import { setActiveTool } from "../../../redux/actions"
import { TOOLS } from "const";

interface DataSettingProps {
  // basicDetails: BasicDetailsTypes;
}
const DataSetting = ({ /*basicDetails*/ }: DataSettingProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (state: any) => state.Profile2,
    (st, p2) => ({
      userConfig: st.userConfig,
      ucLoadUserConfigLoading: st.ucLoadUserConfigLoading,
      activeTool: st.activeTool,
      isAdmin: p2.isAdmin,
    })
  );
  const { activeTool, isAdmin } = useAppSelector(storeData);

  const cssBtnTag = activeTool == TOOLS.TAG_WORK_PLACE_MANAGE ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnFollower = activeTool == TOOLS.TAG_WORK_PLACE_FOLLOWER ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnQuickReply = activeTool == TOOLS.QUICK_CHAT_REPLY ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnGroupMember = activeTool == TOOLS.GROUP_CHAT_MEMBER ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnSyncErpData = activeTool == TOOLS.SYNC_ERP_DATA ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnGeneralSetting = activeTool == TOOLS.GENERAL_SETTING ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnPermVisibleChat = activeTool == TOOLS.PERM_VISIBLE_CHAT_ICON ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnPermVisibleChatSup = activeTool == TOOLS.PERM_VISIBLE_CHAT_ICON_SUP ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";
  const cssBtnNotificationGlobal  = activeTool == TOOLS.NOTIFICATION_GLOBAL ? "btn btn-warning btn-sm w-100" : "btn btn-outline-primary btn-sm w-100";

  return (
    <div className="accordion-body " style={{ display: "flex", flexDirection: "column", gap: "20px", position: "relative" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <button className={cssBtnFollower} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.TAG_WORK_PLACE_FOLLOWER))}>
          <i className="far fa-eye fz-13"></i>&nbsp;ข้อมูลการ Follower
        </button>

        {/* {isAdmin && ( */}
        <button className={cssBtnTag} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.TAG_WORK_PLACE_MANAGE))}>
          <i className="fas fa-at fz-13"></i>&nbsp;ข้อมูล TAG ระบบ <span className="text-info">WorkPlace</span>
        </button>
        {/* )} */}

        {isAdmin && (
          <button className={cssBtnPermVisibleChat} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.PERM_VISIBLE_CHAT_ICON))}>
            <i className="fas fa-lock fz-13"></i>&nbsp;สิทธิ์มองเห็น <span className="text-danger">CUSTOMER CHAT</span>
          </button>
        )}

        {isAdmin && (
          <button className={cssBtnPermVisibleChatSup} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.PERM_VISIBLE_CHAT_ICON_SUP))}>
            <i className="fas fa-lock fz-13"></i>&nbsp;สิทธิ์มองเห็น <span className="text-danger">SUPPLIER CHAT</span>
          </button>
        )}

        <button className={cssBtnQuickReply} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.QUICK_CHAT_REPLY))}>
          <i className="fas fa-atlas fz-13"></i>&nbsp;ข้อมูล คลังคำตอบ ระบบ <span className="text-danger">Chat</span>
        </button>

        <button className={cssBtnNotificationGlobal} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.NOTIFICATION_GLOBAL))}>
          <i className="fas fa-bullhorn fz-13"></i>&nbsp;ข้อมูล <span className="text-danger">ประกาศ</span>
        </button>

        <button className={cssBtnGroupMember} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.GROUP_CHAT_MEMBER))}>
          <i className="fas fa-atlas fz-13"></i>&nbsp;ข้อมูล สมาชิก <span className="text-danger">ห้อง Chat</span>
        </button>

        {isAdmin && (
          <button className={cssBtnSyncErpData} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.SYNC_ERP_DATA))}>
            <i className="fas fa-sync-alt fz-13"></i>&nbsp;SYNC ERP DATA
          </button>
        )}

        <button className={cssBtnGeneralSetting} style={{ textAlign: "left" }} onClick={() => dispatch(setActiveTool(TOOLS.GENERAL_SETTING))}>
          <i className="fa fa-gears fz-13"></i>&nbsp;GENERAL SETTING
        </button>




      </div>
    </div>
  );
};

export default DataSetting;
